/* eslint-disable @typescript-eslint/no-redeclare */
import { Static } from '@sinclair/typebox';

import { JobPayload } from './job-payload.schema';

export type JobCreatePayload = Static<typeof JobCreatePayload>;
export const JobCreatePayload = JobPayload;
